import { render, staticRenderFns } from "./RejectedDocumentsUpload.vue?vue&type=template&id=f4438884&scoped=true"
import script from "./RejectedDocumentsUpload.vue?vue&type=script&lang=js"
export * from "./RejectedDocumentsUpload.vue?vue&type=script&lang=js"
import style0 from "./RejectedDocumentsUpload.vue?vue&type=style&index=0&id=f4438884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4438884",
  null
  
)

export default component.exports